import React from 'react';

import bankIcon from 'icons/bank-transfer.svg';
import creditCardIcon from 'icons/credit-card.svg';
import type { Logo } from 'models/offer';

const DEFAULT_LOGO_ALT = '';

type PaymentMethodLogoProps = {
  paymentMethod: string;
  logo?: Logo;
};

const PaymentMethodLogo = ({ paymentMethod, logo }: PaymentMethodLogoProps) => {
  const logoAlt = logo?.name || DEFAULT_LOGO_ALT;

  const defaultSource =
    paymentMethod === 'bank_transfer' ? bankIcon : creditCardIcon;

  const logoSource = logo?.links.original || defaultSource;

  return (
    <span className="Offer-icon">
      <img src={logoSource} alt={logoAlt} data-testid="paymentMethodLogo" />
    </span>
  );
};

export { PaymentMethodLogo };
